import { ENUM_ROLES } from '@module-role/enums/enum-roles';
import { Values } from '@utils-global/type-values';

export class ActionSetDropDownRolesEnabled {
  static readonly type = ' [Roles dropdown list] provide list of enable roles';
  constructor(public roles: Values<typeof ENUM_ROLES>[]) {}
}
